exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bind-thumb[data-v-17ecf387] { width: 40px; height: 40px; -o-object-fit: cover; object-fit: cover; border-radius: 4px; border: 1px solid #eee;\n}\n", ""]);

// exports
